<template>
  <div>
    <a-modal v-model:visible="visible" title="智能处方" @ok="handleOk" okText="确认" cancelText="取消" :afterClose="closeModal" :cancelButtonProps="{ style: { display: 'none' }}" width="35vw">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="处理类型" required>
          <a-radio-group v-model:value="inputs.pdfCategory">
            <a-radio value="Mifang">伏病方</a-radio>
            <a-radio value="Jingfang">传统经方</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="处方类型" required>
          <a-radio-group v-model:value="inputs.type" @change="handleCheckChange">
            <a-radio value="普通处方">普通处方</a-radio>
            <!-- <a-radio value="膏方">膏方</a-radio> -->
          </a-radio-group>
        </a-form-item>
        <a-form-item label="炮制方法" required>
          <a-radio-group v-model:value="inputs.processingMethod">
            <a-radio value="饮片">饮片</a-radio>
            <a-radio value="颗粒剂">颗粒剂</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>

      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="疾病">
          <!-- <a-radio-group v-model:value="inputs.diseaseList" style="display:block;line-height: 32px;">
            <a-radio value="Mifang">秘方</a-radio>
            <a-radio value="Jingfang">伏病方</a-radio>
          </a-radio-group> -->
          <a-checkbox-group v-if="diseaseList.length>0" v-model:value="inputs.diseaseListValue" style="width: 100%;line-height: 32px;">
            <a-row>
              <a-col :span="8" v-for="item in diseaseList" :key="item.id">
                <a-checkbox :value="item.id">{{item.projectName}}</a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <div class="popconfirm">
            <a-select v-model:value="inputs.disease" show-search placeholder="添加疾病(中文或首字母)" allowClear :filterOption="filterName" style="width: 220px;" @change="handleChangePopconfirm(inputs.disease, '疾病')">
              <a-select-option v-for="item in diseaseOption" :value="item.name">{{ item.name }}</a-select-option>
            </a-select>
            <div class="box" v-if="showDiseasePop">
              <h5>{{inputs.disease}}</h5>
              <div class="content">
                <div v-for="(item,index) in setting">
                  <a-select v-if="item.valueType==='List'" v-model:value="details[index].diagnosisInfo" :placeholder="item.diagnosisName" size="small" style="width: 180px;">
                    <a-select-option v-for="item in item.list" :value="item">{{item}}</a-select-option>
                  </a-select>
                  <a-input size="small" v-else-if="item.valueType==='String'" v-model:value="details[index].diagnosisInfo" :placeholder="item.diagnosisName" />
                </div>

              </div>
              <div class="btnBox">
                <a-button size="small" @click="insertToList('疾病')" type="primary">插入</a-button>
                <a-button size="small" @click="showDiseasePop=false">取消</a-button>
              </div>
            </div>
          </div>

        </a-form-item>
        <a-form-item label="运脉">
          <a-button @click="visible2=true">图选</a-button>
          <span style="margin-left: 10px;">{{inputs.tcmDiagnose}}</span>
        </a-form-item>
        <a-form-item label="症候群">
          <a-checkbox-group v-if="syndromeList.length>0" v-model:value="inputs.syndromeListValue" style="width: 100%;line-height: 32px;">
            <a-row>
              <a-col :span="8" v-for="item in syndromeList" :key="item.id">
                <a-checkbox :value="item.id">{{item.projectName}}</a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <div class="popconfirm">
            <a-select v-model:value="inputs.syndrome" show-search placeholder="添加症候群(中文或首字母)" allowClear :filterOption="filterName" style="width: 220px;" @change="handleChangePopconfirm(inputs.syndrome, '症候群')">
              <a-select-option v-for="item in syndromeOption" :value="item.name">{{ item.name }}</a-select-option>
            </a-select>
            <div class="box" v-if="showSyndromePop">
              <h5>{{inputs.syndrome}}</h5>
              <div class="content">
                <div v-for="(item,index) in setting">
                  <a-select v-if="item.valueType==='List'" v-model:value="details[index].diagnosisInfo" :placeholder="item.diagnosisName" size="small" style="width: 180px;">
                    <a-select-option v-for="item in item.list" :value="item">{{item}}</a-select-option>
                  </a-select>
                  <a-input size="small" v-else-if="item.valueType==='String'" v-model:value="details[index].diagnosisInfo" :placeholder="item.diagnosisName" />
                </div>

              </div>
              <div class="btnBox">
                <a-button size="small" @click="insertToList('症候群')" type="primary">插入</a-button>
                <a-button size="small" @click="showDiseasePop=false">取消</a-button>
              </div>
            </div>
          </div>

        </a-form-item>

      </a-form>
    </a-modal>
    <wuxing v-model="visible2" @wuxingCallback="wuxingCallback" />
  </div>
</template>

<script>
import { SyndromeList, DiseaseList, GetSetting, AddReportItem, Save, AiGenerate } from "/src/api/medicalRecord.js";
import { pinyin } from 'pinyin-pro';
import wuxing from "/src/components/medicalRecord/wuxing.vue";
export default {
  components: {
    wuxing
  },
  data() {
    return {
      visible: this.modelValue,
      visible2: false,
      selectedRows: {},
      columns: [],
      syndromeOption: [],
      diseaseOption: [],
      inputs: {
        pdfCategory: "Mifang",
        type: "普通处方",
        processingMethod: "饮片",
        syndrome: undefined,
        disease: undefined, 
        diseaseListValue: [],
        syndromeListValue: [],
      },
      showSyndromePop: false,
      showDiseasePop: false,
      setting: [],
      details: [],
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue'],
  created() {

  },
  mounted() {
  },
  activated() {

  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    syndromeList: {
      type: Array,
      default: () => [],
    },
    diseaseList: {
      type: Array,
      default: () => [],
    },
    reportId: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    tcmDiagnose: {
      type: String,
      default: "",
    },
    template: {
      type: String,
      default: ""
    }
  },
  watch: {
    modelValue(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit('update:modelValue', val);
    },

  },
  computed: {
  },
  methods: {
    init() {
      console.log("reportId", this.reportId);

      this.getOptions()
      this.inputs.tcmDiagnose = this.tcmDiagnose

    },
    handleCheckChange() {
      console.log(this.inputs.type);

    },
    async detail() { },
    getPinyinFirstInitials(str) {
      if (!str) return '';

      const result = pinyin(str, {
        pattern: 'first',   // 只获取拼音首字母
        toneType: 'none',      // 不要音调
        mode: 'normal',   // 普通模式（非智能分词）
      });

      // 处理返回结果（兼容数组和字符串两种结构）
      if (Array.isArray(result)) {
        return result.map(arr => arr[0]).join('').toLowerCase();
      } else if (typeof result === 'string') {
        return result.replace(/\s+/g, '').toLowerCase(); // 去空格
      }

      return '';
    },
    getPinyinInitials(str) {
      if (!str) return '';

      const result = pinyin(str, {
        toneType: 'none',      // 不要音调
        mode: 'normal',   // 普通模式（非智能分词）
      });

      // 处理返回结果（兼容数组和字符串两种结构）
      if (Array.isArray(result)) {
        return result.map(arr => arr[0]).join('').toLowerCase();
      } else if (typeof result === 'string') {
        return result.replace(/\s+/g, '').toLowerCase(); // 去空格
      }
      return '';
    },
    async handleOk() {
      let inputs = this.inputs
      if (inputs.pdfCategory === "") {
        this.$message.warning("请选择处理类型")
        return
      }
      if (inputs.type === "") {
        this.$message.warning("请选择处方类型")
        return
      }
      if (inputs.processingMethod === "") {
        this.$message.warning("请选择炮制方法")
        return
      }
      let parmas = {
        medicalRecordId: this.id,
        pdfCategory: inputs.pdfCategory,
        type: inputs.type,
        processingMethod: inputs.processingMethod,
        pdfPulse: inputs.tcmDiagnose,
        diseaseItems: inputs.diseaseListValue,
        syndromeItems: inputs.syndromeListValue,
      }
      if (this.template == 'Simple_Futie') {
        parmas.addFields = ["穴位处方"]
        parmas.takingMethod = "敷贴"
      }
      console.log(parmas);
      let res = await AiGenerate(parmas)
      console.log(res);
      if (res.errCode == 0) {
        this.$emit("refreshCallback")
        this.closeModal()
      }

    },
    async onDelete(id) {

      let res = await Delete({ id })
      if (res.errCode == 0) {
        this.data = this.data.filter(function (item) {
          return item.id !== id;
        });
      }

    },
    async getOptions() {
      let syndromeOption = await SyndromeList({ pageSize: -1 })
      let diseaseOption = await DiseaseList({ pageSize: -1 })

      // console.log("diseaseOption", diseaseOption);

      this.syndromeOption = syndromeOption.data.records
      this.diseaseOption = diseaseOption.data.records
    },
    filterName(input, option) {
      // console.log(option);
      const label = option.value; // a-select-option 的显示文本
      const pinyinFirstInitials = this.getPinyinFirstInitials(label); // 获取该选项的拼音首字母
      const pinyinInitials = this.getPinyinInitials(label); // 获取该选项的拼音首字母
      const lowerInput = input.toLowerCase(); // 输入内容统一小写处理
      // console.log(pinyinInitials);

      // 匹配中文 或 拼音首字母
      return (
        label.toLowerCase().includes(lowerInput) ||
        pinyinFirstInitials.toLowerCase().includes(lowerInput) ||
        pinyinInitials.toLowerCase().includes(lowerInput)
      );
    },
    handleChangePopconfirm(value, category) {
      this.showSyndromePop = false
      this.showDiseasePop = false
      let option;
      console.log(category);

      if (category == "症候群") {
        this.showSyndromePop = true
        option = "syndromeOption"
      } else if (category == "疾病") {
        this.showDiseasePop = true
        option = "diseaseOption"
      }
      let id = this[option].find(item => item.name == value).id
      this.getSetting(id, category)

    },
    async getSetting(projectId, category) {
      let res = await GetSetting({ projectId, category })
      this.setting = res.data
      console.log("this.setting", this.setting);

      this.details = res.data.map(item => {
        return {
          diagnosisName: item.diagnosisName,
          diagnosisInfo: undefined,
        }
      })


    },
    async insertToList(category) {
      let id
      if (category === "症候群") {
        id = this.syndromeOption.find(item => item.name == this.inputs.syndrome).id
      } else if (category === "疾病") {
        id = this.diseaseOption.find(item => item.name == this.inputs.disease).id
      }
      let parmas = { reportId: this.reportId, category, projectId: id, projectName: this.inputs.disease, details: this.details }
      if (category === "症候群") {
        parmas.projectName = this.inputs.syndrome
      } else if (category === "疾病") {
        parmas.projectName = this.inputs.disease
      }
      let res = await AddReportItem(parmas)
      this.showDiseasePop = false
      this.showSyndromePop = false
      if (category === "症候群") {
        this.inputs.syndrome = undefined
        this.inputs.syndromeListValue.push(res.data.id)
      } else if (category === "疾病") {
        this.inputs.disease = undefined
        this.inputs.diseaseListValue.push(res.data.id)
      }
      this.$emit("refreshCallback")
    },
    closeModal() {
      this.showDiseasePop = false
      this.showSyndromePop = false
      this.inputs.disease = undefined
      this.inputs.syndrome = undefined
      this.$emit('update:modelValue', false);
    },
    async wuxingCallback(value) {
      // value = ['长', '弦', '滑', '迟', '细']
      this.inputs.tcmDiagnose = value.join(",")

      let parmas = {
        id: this.id,
        tcmDiagnose: this.inputs.tcmDiagnose,
      }
      console.log(parmas);
      this.$emit("refreshCallback", { wuxing: value.join(",") })

      let res = await Save(parmas)
    },

  },
  watch: {

    modelValue(val) {
      this.init()
      this.visible = val
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
.head2 {
  display: flex;
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
}
.head2 span {
  font-weight: bold;
  margin-right: 10px;
}
table {
  width: 80%;
  margin: 0 auto;
  background-color: #f5f5f5;
}
th,
td {
  text-align: center;
  padding: 10px;
}

.popconfirm {
  position: relative;
  display: inline-block;
}
.popconfirm .box {
  position: absolute;
  top: 100%;
  left: 50%;
  background-color: #f1fdff;
  transform: translate(-50%, 7px);
  border: 1px solid #ccc;
  padding: 10px;
  width: 300px;
  z-index: 10;
  box-shadow: 3px 3px 7px #00000052;
  border-radius: 10px;
}
/* popconfirm面的小三角 */
.popconfirm .box::after {
  content: "";
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -100%);
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent #ccc transparent;
}
.popconfirm .box h5 {
  border-bottom: 1px solid #999;
  padding-bottom: 8px;
  font-size: 16px;
  text-align: center;
  letter-spacing: 3px;
}
.popconfirm .box .content {
  margin-bottom: 10px;
}
.popconfirm .box .content > * {
  margin-bottom: 5px;
}

.popconfirm .btnBox {
  display: flex;
  justify-content: center;
}

.popconfirm .btnBox .ant-btn {
  margin-left: 10px;
}
</style>